<template>
  <div>
    <loader :loading="loading || loadingForProducts"/>
    <header class="c-toolbar" v-if="!loading">
      <div class="l-level">
        <div class="l-level__left">
          <img :src="fromModuleDefinition.logo" class="logo" alt="">
          <i class="i-arrow icon-arrow-right"></i>
          <img :src="toModuleDefinition.logo" class="logo" alt="">
          <h1 class="c-toolbar__title title">Disponibilizar produtos</h1>
        </div>
      </div>
    </header>

    <panel v-if="toModule && toModule.identifier === 'shopee'">
      <div class="l-row">
        <form-group :label="$t('shopee.account.label')" :required="true">
          <select v-model="selectedAccount" class="form-select">
            <option v-for="account in shopeeAccounts" :value="account">{{ `${account.shopName} (${account.shopId})`}}
            </option>
          </select>
        </form-group>
      </div>
    </panel>

    <panel v-if="toModule && toModule.identifier === 'tikTokShop'">
      <div class="l-row">
        <form-group :label="$t('tikTokShop.account.label')" :required="true">
          <select v-model="selectedAccount" class="form-select">
            <option disabled selected value="">Selecione uma conta</option>
            <option v-for="account in tikTokShopAccounts" :value="account">{{ `${account.nickname}`}}
            </option>
          </select>
        </form-group>
      </div>
    </panel>

    <panel v-if="toModule && toModule.identifier === 'shein'">
      <div class="l-row">
        <form-group :label="$t('shein.account.label')" :required="true">
          <select v-model="selectedAccount" class="form-select">
            <option disabled selected value="">Selecione uma conta</option>
            <option v-for="account in sheinAccounts" :value="account">{{ `${account.nickname}`}}
            </option>
          </select>
        </form-group>
      </div>
    </panel>

    <panel v-if="toModule && toModule.identifier === 'magalu'">
      <div class="l-row">
        <form-group :label="$t('magalu.account.label')" :required="true">
          <select v-model="selectedAccount" class="form-select">
            <option disabled selected value="">Selecione uma conta</option>
            <option v-for="account in magaluAccounts" :value="account">{{ `${account.identifier}`}}
            </option>
          </select>
        </form-group>
      </div>
    </panel>

    <component :is="marketplaceProvideProduct" ref="marketplaceProvideProduct" v-for="product in products" :key="product" :product="product" :toModule="toModule" :fromModule="fromModule" :account="selectedAccount" />
    <panel>
      <button :disabled="saving" v-bind:class="{ 'is-loading': saving }" class="btn btn--success" @click="save">{{ $t('provide.label') }}</button>
    </panel>
  </div>
</template>

<script>
import api from '@/api'
import { getAllUrlParams } from '@/helper'
import { mapActions, mapGetters } from 'vuex'
import { merge, upperFirst, cloneDeep, floor } from 'lodash'
import Loader from '@/components/template/Loader'
import Panel from '@/components/template/Panel'
import FormGroup from '@/components/template/FormGroup'
import notifier from '@/notifier'
import MarketplaceProvideProductShopee from '@/components/marketplace/shopee/provide/Product'
import MarketplaceProvideProductSkyhub from '@/components/marketplace/skyhub/provide/Product'
import MarketplaceProvideProductNetshoes from '@/components/marketplace/netshoes/provide/Product'
import MarketplaceProvideProductColombo from '@/components/marketplace/colombo/provide/Product'
import MarketplaceProvideProductIntegracommerce from '@/components/marketplace/integracommerce/provide/Product'
import MarketplaceProvideProductCnova from '@/components/marketplace/cnova/provide/Product'
import MarketplaceProvideProductLeroy from '@/components/marketplace/leroy/provide/Product'
import MarketplaceProvideProductCarrefour from '@/components/marketplace/carrefour/provide/Product'
import MarketplaceProvideProductWebcontinental from '@/components/marketplace/webcontinental/provide/Product'
import MarketplaceProvideProductWalmart from '@/components/marketplace/walmart/provide/Product'
import MarketplaceProvideProductMadeira from '@/components/marketplace/madeira/provide/Product'
import MarketplaceProvideProductGfg from '@/components/marketplace/gfg/provide/Product'
import MarketplaceProvideProductZoom from '@/components/marketplace/zoom/provide/Product'
import MarketplaceProvideProductCentauro from '@/components/marketplace/centauro/provide/Product'
import MarketplaceProvideProductAmazon from '@/components/marketplace/amazon/provide/Product'
import MarketplaceProvideProductRicardoEletro from '@/components/marketplace/ricardoEletro/provide/Product'
import MarketplaceProvideProductRenner from '@/components/marketplace/renner/provide/Product'
import MarketplaceProvideProductConectaLa from '@/components/marketplace/conectaLa/provide/Product'
import MarketplaceProvideProductPolishop from '@/components/marketplace/polishop/provide/Product'
import MarketplaceProvideProductSicoob from '@/components/marketplace/sicoob/provide/Product'
import MarketplaceProvideProductPrivalia from '@/components/marketplace/privalia/provide/Product'
import MarketplaceProvideProductDecathlon from '@/components/marketplace/decathlon/provide/Product'
import MarketplaceProvideProductKeepRunning from '@/components/marketplace/keepRunning/provide/Product'
import MarketplaceProvideProductRamarim from '@/components/marketplace/ramarim/provide/Product'
import MarketplaceProvideProductComfortflex from '@/components/marketplace/comfortflex/provide/Product'
import MarketplaceProvideProductSicredi from '@/components/marketplace/sicredi/provide/Product'
import MarketplaceProvideProductMaisCorreios from '@/components/marketplace/maisCorreios/provide/Product'
import MarketplaceProvideProductTikTokShop from '@/components/marketplace/tiktokshop/provide/Product'
import MarketplaceProvideProductShein from '@/components/marketplace/shein/provide/Product'
import MarketplaceProvideProductMagalu from '@/components/marketplace/magalu/provide/Product'

export default {
  data: () => ({
    loading: true,
    accountLoading: false,
    loadingForProducts: true,
    saving: false,
    products: [],
    toModule: null,
    fromModule: null,
    presetCategorization: [],
    presetIndex: 0,
    selectedAccount: {},
    shopeeAccounts: [],
    tikTokShopAccounts: [],
    sheinAccounts: [],
    magaluAccounts: []
  }),
  props: {
    fromModuleType: {
      type: String,
      required: true
    },
    fromModuleIdentifier: {
      type: String,
      required: true
    },
    toModuleType: {
      type: String,
      required: true
    },
    toModuleIdentifier: {
      type: String,
      required: true
    }
  },
  async mounted () {
    this.clearErrors()

    let auxiliary = 0

    this.toModule = {
      type: this.toModuleType,
      identifier: this.toModuleIdentifier
    }

    this.fromModule = {
      type: this.fromModuleType,
      identifier: this.fromModuleIdentifier
    }

    if (this.toModule.identifier === 'shopee') {
      this.accountLoading = true
      try {
        let accounts = []
        accounts = await api.shopee.getAccounts({
          options: {
            active: true
          }
        })

        if (!accounts.total) {
          notifier.error('Você precisa pelo menos ter uma conta ativa para enviar produtos!', 'Conta')
          this.$router.push('/marketplace/shopee/accounts')
        }

        this.shopeeAccounts = accounts.items

        if (accounts.total === 1) {
          this.selectedAccount = this.shopeeAccounts[0]
        }
      } catch (err) {
        notifier.error('Não foi possível buscar as contas do Shopee.')
      } finally {
        this.accountLoading = false
      }
    }

    if (this.toModule.identifier === 'tikTokShop') {
      this.accountLoading = true

      try {
        let accounts = []
        accounts = await api.tikTokShop.getAccounts({
          options: {
            active: true
          }
        })

        if (!accounts.total) {
          notifier.error('Você precisa pelo menos ter uma conta ativa para enviar produtos!', 'Conta')

          this.$router.push('/marketplace/tikTokShop/accounts')
        }

        this.tikTokShopAccounts = accounts.items

        if (accounts.total === 1) {
          this.selectedAccount = this.tikTokShopAccounts[0]
        }
      } catch (err) {
        notifier.error('Não foi possível buscar as contas do Shopee.')
      } finally {
        this.accountLoading = false
      }
    }

    if (this.toModule.identifier === 'shein') {
      this.accountLoading = true

      try {
        let accounts = []
        accounts = await api.shein.getAccounts({
          options: {
            active: true
          }
        })

        if (!accounts.total) {
          notifier.error('Você precisa pelo menos ter uma conta ativa para enviar produtos!', 'Conta')

          this.$router.push('/marketplace/shein/accounts')
        }

        this.sheinAccounts = accounts.items

        if (accounts.total === 1) {
          this.selectedAccount = this.sheinAccounts[0]
        }
      } catch (err) {
        notifier.error('Não foi possível buscar as contas do Shein.')
      } finally {
        this.accountLoading = false
      }
    }

    if (this.toModule.identifier === 'magalu') {
      this.accountLoading = true

      try {
        let accounts = []
        accounts = await api.magalu.getAccounts({
          options: {
            active: true
          }
        })

        if (!accounts.total) {
          notifier.error('Você precisa pelo menos ter uma conta ativa para enviar produtos!', 'Conta')

          this.$router.push('/marketplace/magalu/accounts')
        }

        this.magaluAccounts = accounts.items

        if (accounts.total === 1) {
          this.selectedAccount = this.magaluAccounts[0]
        }
      } catch (err) {
        this.selectedAccount = {
          identifier: '123213123123'
        }
      } finally {
        this.accountLoading = false
      }
    }

    await this.fetchPresets({})

    if (!this.toModuleDefinition || !this.toModuleDefinition.module.configs.product.price) {
      notifier.error('Configuração de preço padrão do módulo não definida.', 'Erro')
      this.redirectToProductProvideList()
    }

    if (this.toModuleDefinition.module.configs.product.price.type === 'percent') {
      auxiliary = this.toModuleDefinition.module.configs.product.price.percent
    }
    if (this.toModuleDefinition.module.configs.product.price.type === 'fixedValue') {
      auxiliary = this.toModuleDefinition.module.configs.product.price.fixedValue
    }

    if (getAllUrlParams().productId) {
      await this.addItemBySourceAndProductId({ source: {type: this.fromModuleType, identifier: this.fromModuleIdentifier}, productId: getAllUrlParams().productId })
    }

    const items = this.getItemsSelected()
    items.forEach(product => {
      product.description = product.description.trim()
      product.status = null
      product.errors = []
      product.attributes = []
      product.variations.forEach(variation => {
        const fields = {
          status: null,
          errors: [],
          selected: (variation.quantity > 0),
          stock: {
            quantity: variation.quantity,
            reducer: this.toModuleDefinition.module.configs.product.stock.reducer
          },
          price: {
            type: this.toModuleDefinition.module.configs.product.price.type,
            cost: 0,
            auxiliary: auxiliary,
            previous: variation.previousPrice,
            current: variation.currentPrice
          }
        }
        merge(variation, fields)
      })
    })
    this.products = items

    if (!this.products.length) {
      this.redirectToProductProvideList()
    }

    setTimeout(() => (this.loading = false), 1500)
  },
  computed: {
    ...mapGetters('itemsSelected', [
      'getItemsSelected'
    ]),
    ...mapGetters('module', [
      'getDefinitionModuleByIdentifierAndType'
    ]),
    ...mapGetters('sendProducts', [
      'getAllVariations'
    ]),
    ...mapGetters('errors', [
      'getError'
    ]),
    ...mapGetters('presets', [
      'getPresetItemsByFromAndTo'
    ]),
    toModuleDefinition () {
      return this.getDefinitionModuleByIdentifierAndType(this.toModuleType, this.toModuleIdentifier)
    },
    fromModuleDefinition () {
      return this.getDefinitionModuleByIdentifierAndType(this.fromModuleType, this.fromModuleIdentifier)
    },
    allVariations () {
      return this.getAllVariations()
    },
    marketplaceProvideProduct () {
      return `MarketplaceProvideProduct${upperFirst(this.toModuleIdentifier)}`
    },
    presets () {
      return this.getPresetItemsByFromAndTo(
        { type: this.fromModuleType, identifier: this.fromModuleIdentifier },
        { type: this.toModuleType, identifier: this.toModuleIdentifier }
      )
    }
  },
  methods: {
    ...mapActions('itemsSelected', [
      'addItemBySourceAndProductId'
    ]),
    ...mapActions('sendProducts', [
      'add',
      'send'
    ]),
    ...mapActions('errors', [
      'clearErrors'
    ]),
    ...mapActions('presets', [
      'fetchPresets'
    ]),
    redirectToProductProvideList () {
      this.$router.push(`/${this.fromModuleType}/${this.fromModuleIdentifier}/products`)
    },
    redirectToProductsSentReport () {
      this.$router.push(`/${this.toModuleType}/${this.toModuleIdentifier}/provide/report/${this.fromModuleType}/${this.fromModuleIdentifier}`)
    },
    async save () {
      this.saving = true

      this.clearErrors()

      let products = []
      this.$refs.marketplaceProvideProduct.map((component) => {
        component.formatProduct().map((variation) => {
          products.push(variation)
        })
      })

      await this.add(products)

      if (this.allVariations.length === 0) {
        this.saving = false
        return notifier.warning('Nenhuma variação foi selecionada!', 'Selecione as variações')
      }

      const sentSuccess = await this.send({
        type: this.toModuleType,
        identifier: this.toModuleIdentifier
      })

      this.saving = false

      if (sentSuccess) {
        this.redirectToProductsSentReport()
      }
    },
    getPresetItemByTypeAndFrom (type, from) {
      const preset = this.presets.find(preset => preset.type === type)

      if (preset === undefined) {
        return null
      }

      if (preset.items.length) {
        let item = null
        switch (type) {
          case 'brand':
            item = preset.items.filter(item => item.from.brand === from.brand)
            break

          case 'color':
            item = preset.items.filter(item => item.from.color === from.color)
            break

          case 'size':
            item = preset.items.filter(item => item.from.size === from.size)
            break

          case 'categorization':
            item = preset.items.filter(item => item.from.category === from.category)
            break
        }

        if (item !== null && item.length === 1) {
          return item[0].to
        }

        return null
      }
    },
    getPresetItemsCategorization (categories) {
      const categoriesForSearchPreset = []
      this.getPresetItemsCategorizationRecursive(categories, categoriesForSearchPreset)

      this.presetCategorization = []

      for (let i in categoriesForSearchPreset) {
        const categories = categoriesForSearchPreset[i]

        const preset = this.getPresetItemByTypeAndFrom('categorization', { category: categories.join(' > ') })

        if (preset !== null) {
          this.presetCategorization.push(preset)
        } else {
          for (let j in categories) {
            const category = categories[j]

            const presetOld = this.getPresetItemByTypeAndFrom('categorization', { category: category })

            if (presetOld !== null) {
              this.presetCategorization.push(presetOld)
            }
          }
        }
      }

      if (this.presetCategorization.length === 1) {
        return cloneDeep(this.presetCategorization[0])
      }

      return null
    },
    getPresetItemsCategorizationRecursive (categories, categoriesForSearchPreset) {
      for (let i in categories) {
        const category = categories[i]

        if (!categoriesForSearchPreset[this.presetIndex]) {
          categoriesForSearchPreset[this.presetIndex] = []
        }

        categoriesForSearchPreset[this.presetIndex].push(category.name)

        if (category.children !== null) {
          this.getPresetItemsCategorizationRecursive(category.children, categoriesForSearchPreset)
        } else {
          this.presetIndex++
        }
      }
    },
    getPresetAddition (currentPrice) {
      const preset = this.presets.find(preset => preset.type === 'addition')

      if (preset === undefined) {
        return 0
      }
      let item = null
      if (preset.items.length) {
        item = preset.items.filter(item => item.from.minRange <= currentPrice && item.to.maxRange >= currentPrice)
      }

      if (item !== null && item.length === 1) {
        if (item[0].additionType === 'percent') {
          return this.round(currentPrice * (item[0].additionValue / 100))
        }
        return item[0].additionValue
      }

      return 0
    },
    round (number) {
      return floor(number * 100) / 100
    },
    validateRequiredAttributes () {
      this.saving = false
    },
    loadingProducts (value) {
      this.loadingForProducts = value
    }
  },
  components: {
    Loader,
    Panel,
    FormGroup,
    MarketplaceProvideProductShopee,
    MarketplaceProvideProductSkyhub,
    MarketplaceProvideProductNetshoes,
    MarketplaceProvideProductColombo,
    MarketplaceProvideProductIntegracommerce,
    MarketplaceProvideProductCnova,
    MarketplaceProvideProductLeroy,
    MarketplaceProvideProductCarrefour,
    MarketplaceProvideProductWebcontinental,
    MarketplaceProvideProductWalmart,
    MarketplaceProvideProductMadeira,
    MarketplaceProvideProductGfg,
    MarketplaceProvideProductZoom,
    MarketplaceProvideProductCentauro,
    MarketplaceProvideProductAmazon,
    MarketplaceProvideProductRicardoEletro,
    MarketplaceProvideProductRenner,
    MarketplaceProvideProductConectaLa,
    MarketplaceProvideProductPolishop,
    MarketplaceProvideProductSicoob,
    MarketplaceProvideProductPrivalia,
    MarketplaceProvideProductDecathlon,
    MarketplaceProvideProductKeepRunning,
    MarketplaceProvideProductRamarim,
    MarketplaceProvideProductComfortflex,
    MarketplaceProvideProductSicredi,
    MarketplaceProvideProductTikTokShop,
    MarketplaceProvideProductShein,
    MarketplaceProvideProductMagalu,
    MarketplaceProvideProductMaisCorreios
  }
}
</script>

<style lang="sass" scoped>
  .logo
    max-height: 30px

  .title
    margin-left: 20px

  .i-arrow
    font-size: 20px
    margin: 0 20px

  .editor
    height: 250px
    margin-bottom: 31px
</style>



// WEBPACK FOOTER //
// Provide.vue?3d1fcdf4